import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { compose } from 'recompose';

import { Button, Icon } from 'shared/components';
import { withEscHandler } from 'shared/hocs/modalWithEscHandler';

import theme from './ModalConsultationMediaDelete.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
};

const ModalConsultationMediaDelete = ({
  intl,
  onCancel,
  onOk,
}) => (
  <div className={ theme.root }>
    <div className={ theme.header }>
      <div>
        <FormattedMessage
          id="Media.MediaDelete.Customer.ConfirmationDialog.title"
          defaultMessage="** Delete Media?"
        />
      </div>
      <button onClick={ onCancel } className={ theme.closingIconContainer } aria-label={ intl.formatMessage({ id: 'General.Cancel', defaultMessage: '** Cancel' }) }>
        <Icon name="naked-x" />
      </button>
    </div>
    <div className={ theme.content }>
      <FormattedMessage
        id="Media.MediaDelete.Customer.ConfirmationDialog.body"
        defaultMessage="**  Are you sure you permanently want to delete this media file?"
      />
    </div>
    <div className={ theme.footer }>
      <Button
        testId="modal-media-file-delete-cancel-button"
        buttonType="naked"
        label={ intl.formatMessage({ id: 'const.button.cancel', defaultMessage: '** Cancel' }) }
        className={ theme.cancelButton }
        onClick={ onCancel }
      />

      <Button
        testId="modal-media-file-delete-confirm-button"
        label={ intl.formatMessage({ id: 'const.button.delete', defaultMessage: '** Delete' }) }
        background="red"
        onClick={ onOk }
      />
    </div>
  </div>
);

ModalConsultationMediaDelete.propTypes = propTypes;

export default compose(
  withEscHandler,
  injectIntl,
)(ModalConsultationMediaDelete);
